/** Defines the maximum number of Ledger Entry updates that can be done. */
export const MAX_LEDGER_ENTRY_UPDATES = 20;
export const MAX_TAG_VALUE_LENGTH = 256;
export const MAX_TAG_KEY_LENGTH = 128;
/** The maximum number of unique tags on a Ledger Entry or Ledger Line. */
export const MAX_TAG_COUNT = 20;

// We should lower this to 10, but we'll start it at 30 to avoid breaking customers.
export const MAX_CONSISTENT_BALANCE_UPDATES = 30;

/*
 * The maximum number of Txs that can be provided to
 * syncCustomTxs and deleteCustomTxs
 */
export const MAX_REQUEST_INPUT_CUSTOM_TXS = 100;

/** The maximum number of items in a list filter */
export const MAX_LIST_FILTER_ITEMS = 100;

/** The maximum number of items in an 'all' filter (AND logic) */
export const MAX_ALL_FILTER_ITEMS = 10;

/** The minimum duration a Schema Ledger Entry needs to be disabled */
export const MIN_SCHEMA_LEDGER_ENTRY_DISABLED_DURATION_SECONDS = 45;

export const MAX_SCHEMA_SIZE_KB = 200;

/** How long an unused workspace invite stays acceptable. */
export const INVITE_EXPIRY_MS = 1000 * 60 * 60 * 72;
